import { bodyBgGradient2 } from "./BodyBgStore";

export const updateBodyBgGradient2 = (value) => bodyBgGradient2.update(oldValue => value);
